export default "__VITE_ASSET__xJxh1Mdi__"